import styled from 'styled-components'

const Label = styled.strong`
  display: block;
  color: #333333;
`

const Font = styled.div`
  font-family: 'purplewave';
  color: #68504c;

  &::before {
    content: ${props => props.font};
  }
`

const Icon = styled.i`
  color: #68504c;
`

const Link = styled.a`
  text-decoration: none;
  ${props => props.expanded && 'background-color : white;'}
`

export default ({
  id,
  font,
  icon,
  expanded,
  label,
  path,
  className,
  onClick = null,
}) => {
  return (
    <Link
      id={id}
      className={className}
      expanded={expanded}
      href={path}
      onClick={onClick}
    >
      {font ? <Font font={font} /> : <Icon className={`bi bi-${icon}`} />}
      {label && <Label>{label}</Label>}
    </Link>
  )
}
